import {
  ForgeArtifact,
  ForgeBuildArtifact,
  ForgeFigmaArtifact,
  ForgeFileArtifact,
  ForgeSpecArtifact,
} from "@supernova-studio/model";
import { z } from "zod";

export const DTOCreateForgeBuildArtifact = ForgeBuildArtifact.omit({
  id: true,
  createdAt: true,
  projectIterationId: true,
});
export const DTOCreateForgeFileArtifact = ForgeFileArtifact.omit({
  id: true,
  createdAt: true,
  projectIterationId: true,
});
export const DTOCreateForgeFigmaArtifact = ForgeFigmaArtifact.omit({
  id: true,
  createdAt: true,
  projectIterationId: true,
});
export const DTOCreateForgeSpecArtifact = ForgeSpecArtifact.omit({
  id: true,
  createdAt: true,
  projectIterationId: true,
});

export const DTOUpdateForgeBuildArtifact = DTOCreateForgeBuildArtifact.extend({ id: z.string() });
export const DTOUpdateForgeFileArtifact = DTOCreateForgeFileArtifact.extend({ id: z.string() });
export const DTOUpdateForgeFigmaArtifact = DTOCreateForgeFigmaArtifact.extend({ id: z.string() });
export const DTOUpdateForgeSpecArtifact = DTOCreateForgeSpecArtifact.extend({ id: z.string() });

export const DTOForgeArtifact = ForgeArtifact;
export const DTOForgeBuildArtifact = ForgeBuildArtifact;
export const DTOForgeFileArtifact = ForgeFileArtifact;
export const DTOForgeFigmaArtifact = ForgeFigmaArtifact;
export const DTOForgeSpecArtifact = ForgeSpecArtifact;

export const DTOCreateForgeArtifact = z.union([
  DTOCreateForgeBuildArtifact,
  DTOCreateForgeFileArtifact,
  DTOCreateForgeFigmaArtifact,
  DTOCreateForgeSpecArtifact,
]);
export const DTOUpdateForgeArtifact = z.union([
  DTOUpdateForgeFileArtifact,
  DTOUpdateForgeBuildArtifact,
  DTOUpdateForgeSpecArtifact,
  DTOUpdateForgeFigmaArtifact,
]);

export const DTOCreateForgeArtifactResponse = z.object({
  artifact: DTOForgeArtifact,
});

export const DTOUpdateForgeArtifactResponse = z.object({
  artifact: DTOForgeArtifact.nullable(),
});

export const DTODeleteForgeArtifactResponse = z.object({
  ok: z.literal(true),
});

export const DTOForgeArtifactsListResponse = z.object({
  artifacts: z.array(DTOForgeArtifact),
});

export const DTOForgeArtifactGetResponse = z.object({
  artifact: DTOForgeArtifact.nullable(),
});

export type DTOForgeArtifactsListResponse = z.infer<typeof DTOForgeArtifactsListResponse>;
export type DTOForgeArtifactGetResponse = z.infer<typeof DTOForgeArtifactGetResponse>;
export type DTOForgeArtifact = z.infer<typeof DTOForgeArtifact>;
export type DTOForgeBuildArtifact = z.infer<typeof DTOForgeBuildArtifact>;
export type DTOForgeFileArtifact = z.infer<typeof DTOForgeFileArtifact>;
export type DTOForgeFigmaArtifact = z.infer<typeof DTOForgeFigmaArtifact>;
export type DTOForgeSpecArtifact = z.infer<typeof DTOForgeSpecArtifact>;
export type DTOCreateForgeArtifact = z.infer<typeof DTOCreateForgeArtifact>;
export type DTOUpdateForgeArtifact = z.infer<typeof DTOUpdateForgeArtifact>;
export type DTOCreateForgeArtifactResponse = z.infer<typeof DTOCreateForgeArtifactResponse>;
export type DTOUpdateForgeArtifactResponse = z.infer<typeof DTOUpdateForgeArtifactResponse>;
export type DTODeleteForgeArtifactResponse = z.infer<typeof DTODeleteForgeArtifactResponse>;
export type DTOCreateForgeBuildArtifact = z.infer<typeof DTOCreateForgeBuildArtifact>;
export type DTOCreateForgeFileArtifact = z.infer<typeof DTOCreateForgeFileArtifact>;
export type DTOCreateForgeFigmaArtifact = z.infer<typeof DTOCreateForgeFigmaArtifact>;
export type DTOCreateForgeSpecArtifact = z.infer<typeof DTOCreateForgeSpecArtifact>;
export type DTOUpdateForgeBuildArtifact = z.infer<typeof DTOUpdateForgeBuildArtifact>;
export type DTOUpdateForgeFileArtifact = z.infer<typeof DTOUpdateForgeFileArtifact>;
export type DTOUpdateForgeSpecArtifact = z.infer<typeof DTOUpdateForgeSpecArtifact>;
export type DTOUpdateForgeFigmaArtifact = z.infer<typeof DTOUpdateForgeFigmaArtifact>;
